import React from 'react';

import { IconsProvider } from 'presentation/hooks/icons';
import { PlaylistProvider } from 'presentation/hooks/playlist';
import { UserProvider } from './user';

interface IProps {
    children: React.ReactNode
}

export const AppProvider = ({ children }: IProps) => (
    <IconsProvider>
        <PlaylistProvider>
            <UserProvider>
                {children}
            </UserProvider>
        </PlaylistProvider>
    </IconsProvider>
);
